

/**
 * Try to get modal content for a card link
 *
 * @param {object} cardLink
 *
 * @returns {boolean}
 */
function biro_cardLinkModalContent( cardLink ) {

  // Init
  let retval = false;

  // Look for post ID
  let postID = cardLink.getAttribute( 'data-post-id' );

  if ( postID ) {

    // Get the markup element
    let modalContentCloseEl = document.getElementById( 'biro-modal-content-close-' + postID );
    let modalContentEl      = document.getElementById( 'biro-modal-content-' + postID );

    if ( modalContentCloseEl && modalContentEl ) {

      // Get the markup
      let modalContentClose = modalContentCloseEl.textContent;
      let modalContent      = modalContentEl.textContent;

      if ( modalContentClose && modalContent ) {

        // Flag as active
        retval = true;

        // Do overlay
        showOverlay( 'modal-content-overlay', 10000 );

        // Create modal
        let modal          = document.createElement( 'div' );
        let modalContainer = document.createElement( 'div' );
        let modalRow       = document.createElement( 'div' );
        let modalCol       = document.createElement( 'div' );
        let modalCloseWrap = document.createElement( 'div' );
        let modalWrap      = document.createElement( 'div' );

        // Set the classes
        modal.setAttribute( 'class', 'modal-content' );
        modalContainer.setAttribute( 'class', 'container' );
        modalRow.setAttribute( 'class', 'row' );
        modalCol.setAttribute( 'class', 'col-md-13 offset-md-1 col-lg-11 offset-lg-2 col-xl-9 offset-xl-3' );
        modalCloseWrap.setAttribute( 'class', 'modal-content-close-wrap' );
        modalWrap.setAttribute( 'class', 'modal-content-wrap' );
        modalWrap.setAttribute( 'role', 'dialog' );
        modalWrap.setAttribute( 'aria-labelledby', 'modal-content-heading' );
        modalWrap.setAttribute( 'aria-modal', 'true' );

        // Set the z-index
        modal.style.zIndex = 10001;

        // Add content
        modalCloseWrap.innerHTML = modalContentClose;
        modalWrap.innerHTML = modalContent;
        modalCol.appendChild( modalCloseWrap );
        modalCol.appendChild( modalWrap );
        modalRow.appendChild( modalCol );
        modalContainer.appendChild( modalRow );
        modal.appendChild( modalContainer );

        // Display the modal
        document.body.appendChild( modal );

        // Put the focus in it
        modal.focus();

        // Add the event listener for the tab key for focus trapping
        document.addEventListener( 'keydown', handleFocusTrap );

        // Add a click event listener for close button
        document.getElementById( 'modal-content-close' ).addEventListener( 'click', function ( event ) {
          biro_removeModalContent( modal );
        } );

      }

    }

  }

  return retval;

}


/**
 * Remove open modal content
 *
 * @param {object} modal
 *
 * @return {void}
 */
function biro_removeModalContent( modal ) {

  // Init
  modal = modal ? modal : document.querySelector( '.modal-content' );

  // Remove the event listener for focus trapping
  document.removeEventListener( 'keydown', handleFocusTrap );

  // Remove modal
  modal.remove();

  // Close overlay
  hideOverlay( 'modal-content-overlay' );

}